import React from "react";
import Aboutus from "../../assets/aboutus.jpg";
import Bgabout from "../../assets/backgroundabout.svg";
import Cloud from "../../assets/icon/could.svg";
import Icon from "../../assets/icon-1.svg";
import Hotel from "../../assets/hotel.svg";
import Pathway from "../../assets/pathway.svg";
import User from "../../assets/users.svg";
import UAEFlag from "../../assets/UAE.svg";
import UAEicon from "../../assets/icon/uaeicon.svg";
import Indiaflag from "../../assets/India.svg";
import Indiaicon from "../../assets/icon/Indiaicon.svg";
import OmanFlag from "../../assets/Oman.svg";
import Omanicon from "../../assets/icon/omanicon.svg";
import RussiaFlag from "../../assets/Russia.svg";
import Russiaicon from "../../assets/icon/russiaicon.svg";
import UK from "../../assets/UK.svg";
import UKicon from "../../assets/icon/ukicon.svg";
import Tanzania from "../../assets/Tanzania.svg";
import Tanzaniaicon from "../../assets/icon/tanzaniaicon.svg";
import HongKong from "../../assets/Honk Kong.svg";
import HongKongicon from "../../assets/icon/hongkongicon.svg";
import Vission from "../../assets/vission.svg";
import Mission from "../../assets/mission.svg";
import Core from "../../assets/core.svg";
import Image1 from "../../assets/aboutimage1.png";
import Image2 from "../../assets/aboutimage2.png";
import Image3 from "../../assets/aboutimage3.png";
import Playstore from "../../assets/icon/googlepay.svg";
import Appstore from "../../assets/icon/appstore.svg";
import QrCode from "../../assets/icon/qrcode.svg";
import ManTarvel from "../../assets/icon/man-traveling.svg";
import Mobile from "../../assets/icon/mobile.png";

function aboutus() {
  return (
    <div>
      <div className="sectionbg">
        <div className="container mx-auto p-5 md:p-8 lg:px-15">
          <div className="flex gap-5 flex-col justify-center pb-10 pt-5">
            <h1 className="font-bold text-center font-primary text-[40px] leading-[30px]">
              About Us
            </h1>
            <p className="font-primary text-xl text-center font-bold">
              We’re the best B2B Travel Portal
            </p>
            <div className="w-full h-auto md:h-96">
              <img
                src={Aboutus}
                alt="fbt-b2b"
                className="h-full w-full object-cover rounded-[15px]"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="container mx-auto my-4 p-5 md:p-8 md:my-10 lg:px-15">
        <div className="flex flex-col md:items-center">
          <span className="flex gap-2 items-baseline justify-start md:justify-center my-1 text-black">
            <img src={Icon} alt="fbt-b2b" />
            <h2 className="font-primary font-bold text-xl md:text-2xl">
              We Value your Efforts
            </h2>
          </span>
          <h1 className="font-semibold w-full mt-5 mb-5 text-2xl md:text-4xl md:mb-10 md:text-center md:w-3/4">
            Making your travel dreams easy and enjoyable every step of the way.
          </h1>
          <p className="md:text-center font-normal text-sm sm:text-xl">
            Welcome to FBT, your trusted partner in seamless travel management
            and destination services. Since our establishment in 2016, FBT
            Adventures has evolved into a leading Travel Management Company in
            the Middle East. We specialize in offering top-notch solutions for
            travel agencies, tour operators, and DMCs, enhancing business
            efficiency with a customized CRM, robust API integrations, and
            unparalleled customer support.
            <br />
            <br /> Our experienced and highly qualified team is dedicated to
            providing personalized hospitality and innovative travel solutions.
            We have expanded our services from ground handling to include
            destination wedding planning and ultra-luxury experiences across the
            UAE, Oman, and the UK. Committed to excellence, reliability, and
            innovation, we ensure our clients receive the best travel
            experiences.
          </p>
        </div>
      </div>
      <div className="sectionbg">
        <div className="container mx-auto grid grid-cols-1 gap-10 py-10  px-5 md:px-8 lg:px-15 lg:grid-cols-3">
          <div>
            <span className="flex gap-2 items-center justify-center my-1 text-black">
              <img src={Core} alt="fbt-b2b" />
            </span>
            <h1 className="font-semibold text-center mt-5 text mb-5 text-lg sm:text-3xl">
              Our Core Values
            </h1>
            <p className="text-center font-normal text-sm sm:text-base">
              At FBT, we are dedicated to delivering unparalleled service
              standards and upholding the core values that form the foundation
              of all our brands. Through a meticulous vetting process, we ensure
              we recruit top-tier talent in the industry. Our core values are
              inspired by the principles and integrity of our founders and
              executive leadership, guiding us in every endeavor
            </p>
          </div>
          <div>
            <span className="flex gap-2 items-center justify-center my-1 text-black">
              <img src={Vission} alt="fbt-b2b" />
            </span>
            <h1 className="font-semibold text-center mt-5 text mb-5 text-lg sm:text-3xl">
              Our Vision
            </h1>
            <p className="text-center font-normal text-sm sm:text-base">
              Our vision is to be the most reliable and reputed DMC Services
              Provider in the region, known for our integrity, innovation, and
              superior service quality. We aspire to continuously expand our
              range of services, including destination wedding planning and
              ultra-luxury experiences, while maintaining our personalized
              approach to hospitality. By leveraging our expertise and
              commitment, we aim to set a new standard in B2B travel portals,
              ensuring our clients receive the best travel experiences
            </p>
          </div>
          <div>
            <span className="flex gap-2 items-center justify-center my-1 text-black">
              <img src={Mission} alt="fbt-b2b" />
            </span>
            <h1 className="font-semibold text-center mt-5 text mb-5 text-lg sm:text-3xl">
              Our Mission
            </h1>
            <p className="text-center font-normal text-sm sm:text-base">
              Our mission is to lead the travel management industry in the
              Middle East by providing top-notch, reliable, and innovative
              solutions for travel agencies, tour operators, and DMCs. We are
              dedicated to enhancing business efficiency and providing
              unparalleled customer support. Our goal is to offer exceptional
              travel experiences that exceed our clients' expectations through
              personalized service and a commitment to excellence.
            </p>
          </div>
        </div>
      </div>
      <div>
        <div className="container mx-auto grid grid-cols-1 gap-10 lg:grid-cols-3 my-4 p-5 md:p-8 md:my-10 lg:px-15">
          <div className="gap-2 flex-col items-center p-3">
            <div class="hover01 column">
              <div>
                <figure>
                  <span className="flex gap-2 items-center justify-center my-1">
                    <img src={Image1} alt="fbt-b2b" />
                  </span>
                </figure>
              </div>
            </div>
            <span className="flex gap-2 items-baseline justify-center my-3 font-primary">
              <img src={Pathway} alt="fbt-b2b" />
              <h2 className="font-primary font-bold text-2xl">10000+</h2>
            </span>
            <p className="text-center font-bold text-base font-[#000929]">
              Sightseeing items and Tours Covering 500 cities
            </p>
          </div>
          <div className="gap-2 flex-col items-center p-3">
            <div class="hover01 column">
              <div>
                <figure>
                  <span className="flex gap-2 items-center justify-center my-1">
                    <img src={Image2} alt="fbt-b2b" />
                  </span>
                </figure>
              </div>
            </div>
            <span className="flex gap-2 items-baseline justify-center my-3 font-primary">
              <img src={Hotel} alt="fbt-b2b" />
              <h2 className="font-primary font-bold text-2xl">640,000+</h2>
            </span>
            <p className="text-center font-bold text-base font-[#000929]">
              Hotels & Apartments Worldwide
            </p>
          </div>

          <div className="gap-2 flex-col items-center p-3">
            <div class="hover01 column">
              <div>
                <figure>
                  <span className="flex gap-2 items-center justify-center my-1">
                    <img src={Image3} alt="fbt-b2b" />
                  </span>
                </figure>
              </div>
            </div>
            <span className="flex gap-2 items-baseline justify-center my-3 font-primary">
              <img src={User} alt="fbt-b2b" />
              <h2 className="font-primary font-bold text-2xl">10000+</h2>
            </span>
            <p className="text-center font-bold text-base font-[#000929]">
              Our Active User's All over the world
            </p>
          </div>
        </div>
      </div>
      <div
        className="sectionbg"
        style={{
          backgroundImage: `url(${Bgabout})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "bottom",
        }}
      >
        <div className="container mx-auto gap-10 py-10 px-5 md:p-8 lg:px-15">
          <div>
            <span className="flex gap-2 items-baseline justify-center my-1 text-black">
              <img src={Icon} alt="fbt-b2b" />
              <h2 className="font-primary font-bold text-2xl">There for You</h2>
            </span>
            <h1 className="font-semibold text-center mt-5 text mb-5 text-3xl sm:text-4xl">
              Our DMC Presence
            </h1>
            <div className="flex flex-wrap justify-center gap-10 py-10  px-5 md:px-8 lg:px-15 lg:grid-cols-3">
              <div class="hover01 column">
                <div>
                  <figure>
                    <div className="flex gap-2 flex-col items-center bg-white p-3 shadow-inner rounded-xl">
                      <span className="flex gap-2 items-center justify-center my-1 text-black">
                        <img
                          src={Indiaflag}
                          alt="fbt-b2b"
                          className="border-2"
                        />
                      </span>
                      <span className="flex gap-2 items-center justify-center my-1 font-primary">
                        <img src={Indiaicon} alt="fbt-b2b" />
                        <h2 className="font-primary font-bold text-xl">
                          India
                        </h2>
                      </span>
                    </div>
                  </figure>
                </div>
              </div>
              <div class="hover01 column">
                <div>
                  <figure>
                    <div className="flex gap-2 flex-col items-center bg-white p-3 shadow-inner rounded-xl">
                      <span className="flex gap-2 items-center justify-center my-1 text-black">
                        <img src={UAEFlag} alt="fbt-b2b" className="border-2" />
                      </span>
                      <span className="flex gap-2 items-center justify-center my-1 font-primary">
                        <img src={UAEicon} alt="fbt-b2b" className="border-2" />
                        <h2 className="font-primary font-bold text-xl">
                          Dubai
                        </h2>
                      </span>
                    </div>
                  </figure>
                </div>
              </div>
              <div class="hover01 column">
                <div>
                  <figure>
                    <div className="flex gap-2 flex-col items-center bg-white p-3 shadow-inner rounded-xl">
                      <span className="flex gap-2 items-center justify-center my-1 text-black">
                        <img src={UK} alt="fbt-b2b" className="border-2" />
                      </span>
                      <span className="flex gap-2 items-center justify-center my-1 font-primary">
                        <img src={UKicon} alt="fbt-b2b" />
                        <h2 className="font-primary font-bold text-xl">
                          United Kingdom
                        </h2>
                      </span>
                    </div>
                  </figure>
                </div>
              </div>
              <div class="hover01 column">
                <div>
                  <figure>
                    <div className="flex gap-2 flex-col items-center bg-white p-3 shadow-inner rounded-xl">
                      <span className="flex gap-2 items-center justify-center my-1 text-black">
                        <img
                          src={RussiaFlag}
                          alt="fbt-b2b"
                          className="border-2"
                        />
                      </span>
                      <span className="flex gap-2 items-center justify-center my-1 font-primary">
                        <img src={Russiaicon} alt="fbt-b2b" />
                        <h2 className="font-primary font-bold text-xl">
                          Russia
                        </h2>
                      </span>
                    </div>
                  </figure>
                </div>
              </div>
              <div class="hover01 column">
                <div>
                  <figure>
                    <div className="flex gap-2 flex-col items-center bg-white p-3 shadow-inner rounded-xl">
                      <span className="flex gap-2 items-center justify-center my-1 text-black">
                        <img
                          src={OmanFlag}
                          alt="fbt-b2b"
                          className="border-2"
                        />
                      </span>
                      <span className="flex gap-2 items-center justify-center my-1 font-primary">
                        <img src={Omanicon} alt="fbt-b2b" />
                        <h2 className="font-primary font-bold text-xl">Oman</h2>
                      </span>
                    </div>
                  </figure>
                </div>
              </div>
              <div class="hover01 column">
                <div>
                  <figure>
                    <div className="flex gap-2 flex-col items-center bg-white p-3 shadow-inner rounded-xl">
                      <span className="flex gap-2 items-center justify-center my-1 text-black">
                        <img
                          src={Tanzania}
                          alt="fbt-b2b"
                          className="border-2"
                        />
                      </span>
                      <span className="flex gap-2 items-center justify-center my-1 font-primary">
                        <img src={Tanzaniaicon} alt="fbt-b2b" />
                        <h2 className="font-primary font-bold text-xl">
                          Tanzania
                        </h2>
                      </span>
                    </div>
                  </figure>
                </div>
              </div>
              <div class="hover01 column">
                <div>
                  <figure>
                    <div className="flex gap-2 flex-col items-center bg-white p-3 shadow-inner rounded-xl">
                      <span className="flex gap-2 items-center justify-center my-1 text-black">
                        <img
                          src={HongKong}
                          alt="fbt-b2b"
                          className="border-2"
                        />
                      </span>
                      <span className="flex gap-2 items-center justify-center my-1 font-primary">
                        <img src={HongKongicon} alt="fbt-b2b" />
                        <h2 className="font-primary font-bold text-xl">
                          Hong Kong
                        </h2>
                      </span>
                    </div>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="relative my-0 md:my-10">
        <img
          src={Cloud}
          alt="fbtb2b"
          className="absolute top-[5%] left-[50%]"
        />
        <img
          src={Cloud}
          alt="fbtb2b"
          className="absolute top-[12%] left-[30%]"
        />
        <img
          src={Cloud}
          alt="fbtb2b"
          className="absolute top-[2%] left-[10%]"
        />
        <img
          src={Cloud}
          alt="fbtb2b"
          className="absolute top-[5%] left-[80%] hidden md:block"
        />
        <div className="container mx-auto p-5 md:p-8 lg:px-15">
          <div className="py-10 flex flex-col justify-between lg:flex-row">
            <div className="w-full flex flex-col gap-1 lg:w-2/5">
              <div className="font-semibold font-primary text-base mb-3 text-center md:text-left">
                Get all your trip detail in our Mobile App
              </div>
              <div className="font-semibold font-primary text-3xl mb-3 text-center md:text-left">
                <span className="text-[rgb(24,119,242)]">
                  Journey<span className="text-[#e51e25]">X</span>
                </span>{" "}
                the one stop destination for all your trip worries
              </div>
              <div className="flex flex-wrap flex-col items-center justify-center gap-5 my-5 sm:flex-row md:justify-start">
                <div class="hover01 column">
                  <div>
                    <figure>
                      <img
                        src={Appstore}
                        className="max-w-48 w-full"
                        alt="fbt-b2b"
                      />
                    </figure>
                  </div>
                </div>
                <div class="hover01 column">
                  <div>
                    <figure>
                      <img
                        src={Playstore}
                        className="max-w-48 w-full"
                        alt="fbt-b2b"
                      />
                    </figure>
                  </div>
                </div>
              </div>
              <div className="flex flex-col items-center gap-5 my-5 justify-center md:justify-start md:flex-row">
                <img src={QrCode} alt="fbt-b2b" />
                <div className="font-semibold font-primary text-lg mb-3 text-center md:text-left ">
                  Scan the QR code to install JourneyX Mobile App
                </div>
              </div>
            </div>
            <div className="relative flex w-full lg:w-[60%] justify-center pt-10 md:justify-end lg:pt-0">
              <img
                src={ManTarvel}
                alt="fbt-b2b"
                className="absolute z-10 left-[-120px] top-[15%] hidden md:block"
              />
              <div className="relative">
                <img src={Mobile} alt="fbt-b2b" className="w-full" />
                {/* <img src={Shadow} alt="fbt-b2b" className="absolute bottom-[-20%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 hidden md:block lg:bottom-[-5%]"/> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default aboutus;
